// add crisp segments - filterung in crisp

export default function crispSegments($domain) {
    const $crispActivation = document.getElementById('activate-crisp');
    if ($crispActivation) {
        $crisp.push(["set", "session:segments", [[$domain, "website"]]]);
    }
}
